// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var $$String = require("bs-platform/lib/js/string.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var Belt_MapString = require("bs-platform/lib/js/belt_MapString.js");

var numberRegex = /^[+-]?(?=.)*\d*(?:\.\d+)?$/;

var approxNumberRegex = /^[+-]?(?=.)*\d*(?:\.\d+)?~$/;

var stringRegex = /^".*"$/;

var byteRegex = /^[0-9a-f]{2}h|[0,1]{8}b|\d{1,3}d$/i;

function unquote(str) {
  return str.replace(/^"/, "").replace(/"$/, "");
}

function init(str) {
  return $$String.sub(str, 0, str.length - 1 | 0);
}

function getPrecision(x) {
  var s = x.replace(/e\+\d+$/, "");
  var d = s.indexOf(".") + 1 | 0;
  if (d === 0) {
    return 0;
  } else {
    return s.length - d | 0;
  }
}

function parse(str) {
  switch (str) {
    case "" :
        return /* Empty */0;
    case "-Inf" :
        return /* Number */Block.__(0, [Pervasives.neg_infinity]);
    case "+Inf" :
    case "Inf" :
        return /* Number */Block.__(0, [Pervasives.infinity]);
    case "NaN" :
        return /* NaN */1;
    case "error" :
        return /* RaisedError */2;
    case "false" :
        return /* Boolean */Block.__(2, [false]);
    case "no-pulse" :
        return /* Pulse */Block.__(5, [false]);
    case "pulse" :
        return /* Pulse */Block.__(5, [true]);
    case "true" :
        return /* Boolean */Block.__(2, [true]);
    default:
      if (numberRegex.test(str)) {
        return /* Number */Block.__(0, [Number(str)]);
      } else if (approxNumberRegex.test(str)) {
        var strWithoutTilde = str.replace(/~$/, "");
        var num = Number(strWithoutTilde);
        return /* ApproxNumber */Block.__(1, [
                  num,
                  getPrecision(strWithoutTilde)
                ]);
      } else if (stringRegex.test(str)) {
        return /* String */Block.__(3, [unquote(str)]);
      } else if (byteRegex.test(str)) {
        var str$1 = str;
        if (/b$/.test(str$1)) {
          return /* Byte */Block.__(4, [Caml_format.caml_int_of_string("0b" + init(str$1))]);
        } else if (/h$/.test(str$1)) {
          return /* Byte */Block.__(4, [Caml_format.caml_int_of_string("0x" + init(str$1))]);
        } else if (/d$/.test(str$1)) {
          return /* Byte */Block.__(4, [Caml_format.caml_int_of_string(init(str$1))]);
        } else {
          return /* Invalid */Block.__(6, [str$1]);
        }
      } else {
        return /* Invalid */Block.__(6, [str]);
      }
  }
}

function get(t, column) {
  return Belt_Option.flatMap(Belt_MapString.get(t, column), (function (value) {
                if (typeof value === "number" && value === 0) {
                  return ;
                } else {
                  return value;
                }
              }));
}

var commentsRegEx = /\/\/(.(?=([^"]*"[^"]*")*[^"]*$))+/gm;

var emptyLinesRegEx = /^\s+$/gm;

function tabSplit(x) {
  return Belt_List.map(Belt_List.fromArray(x.split("\t")), (function (prim) {
                return prim.trim();
              }));
}

function listDataLines(tsvSource) {
  return Belt_List.keep(Belt_List.fromArray(tsvSource.replace(/\r/gm, "").replace(commentsRegEx, "").replace(emptyLinesRegEx, "").split("\n")), (function (x) {
                return x !== "";
              }));
}

function parse$1(tsvSource) {
  var lines = listDataLines(tsvSource);
  var match = Belt_List.head(lines);
  if (match !== undefined) {
    var header = tabSplit(match);
    var lineToRecord = function (line) {
      var __x = Belt_List.map(tabSplit(line), parse);
      var pairs = Belt_List.zip(header, __x);
      return Belt_MapString.fromArray(Belt_List.toArray(pairs));
    };
    return Belt_List.map(Belt_List.keep(Belt_List.tailExn(lines), (function (x) {
                      return x !== "";
                    })), lineToRecord);
  } else {
    return /* [] */0;
  }
}

var Value = { };

var Record = {
  get: get
};

var map = Belt_List.map;

var mapWithIndex = Belt_List.mapWithIndex;

exports.Value = Value;
exports.Record = Record;
exports.map = map;
exports.mapWithIndex = mapWithIndex;
exports.listDataLines = listDataLines;
exports.tabSplit = tabSplit;
exports.parse = parse$1;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ../xod-tabtest/src/TabData.bs.js
// module id = 1479
// module chunks = 0